<template>
  <div class="chart-card">
    <div class="chart-header">
      <div>
        <h2 class="chart-title">
          Total Deposits Amount
        </h2>
        <p class="chart-subtitle">
          {{ dateRangeParsed }}
        </p>
      </div>
      <div class="dropdown">
        <v-select
          v-model="dataSelectChartValue"
          :options="dataSelectOptionsChart"
          label="name"
          placeholder="Day"
          :clearable="false"
          :class="[
            'call-select'
          ]"
          @input="$emit('dataSelectChartValue', dataSelectChartValue)">
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <font-awesome-icon :icon="dataIconDown" />
            </span>
          </template>
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>
      </div>
    </div>
    <div class="chart-body">
      <canvas ref="barChart" />
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import moment from 'moment';
import selectDepositsPeriod from '../../../mixins/select/selectDepositsPeriod';

export default {
  name: 'BarChart',
  mixins: [selectDepositsPeriod],
  props: {
    totalAmountByDate: {
      type: Array,
      required: true
    },
    formattedRange: {
      type: Array,
      required: true
    },
    dataSelectChartValueId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      chart: null,
      dataSelectOptionsChart: [
        { id: 'day', name: 'Day' },
        { id: 'week', name: 'Week' },
        { id: 'month', name: 'Month' }
      ],
      dataSelectChartValue: { id: 'day', name: 'Day' }
    };
  },

  computed: {
    dateRangeParsed () {
      return `${moment(this.formattedRange[0]).format(
        'D MMMM YYYY'
      )} - ${moment(this.formattedRange[1]).format('D MMMM YYYY')}`;
    }
  },

  watch: {
    totalAmountByDate: {
      handler () {
        this.renderChart();
      },
      deep: true
    }
  },

  mounted () {
    this.dataSelectChartValue = this.dataSelectOptionsChart.find(el => el.id === this.dataSelectChartValueId);
    this.renderChart();
  },

  beforeDestroy () {
    if (this.chart) this.chart.destroy();
  },

  methods: {
    renderChart () {
      if (this.chart) this.chart.destroy();

      const labels = this.totalAmountByDate.map(item =>
        new Date(item.stats_date).getDate()
      );
      const data = this.totalAmountByDate.map(item => item.deposits_sum_usd);
      const fullDates = this.totalAmountByDate.map(item => item.stats_date);

      const ctx = this.$refs.barChart.getContext('2d');

      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: '',
              data: [...data],
              backgroundColor: '#4CAF50'
              // borderRadius: 4,
              // barThickness: 16
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
            duration: 800,
            easing: 'easeOutQuart'
          },
          legend: { display: false },
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  callback: value => `$${value}`,
                  fontColor: '#333',
                  fontSize: 12,
                  beginAtZero: true
                },
                maxTicksLimit: 6
                // gridLines: { display: false }
                // gridLines: {
                //   color: '#eee',
                //   drawBorder: false,

                // }
              }
            ],
            xAxes: [
              {
                gridLines: { display: false },
                ticks: {
                  callback: (value, index) => {
                    return fullDates[index];
                    // return `${moment(fullDates[index]).format('DD.MM')}`;
                  },
                  fontColor: '#333',
                  fontSize: 12
                }
              }
            ]
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            displayColors: false,
            callbacks: {
              title: (tooltipItem, data) => {
                const index = tooltipItem[0].index;
                const value = data.datasets[0].data[index];
                return `$${value}`;
              },
              label: (tooltipItem, data) => {
                const index = tooltipItem.index;
                const fullDate = fullDates[index];
                return `${fullDate}`;
              }
            }
          },
          hover: {
            mode: 'index',
            intersect: false
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">

.chart-card {
  .vs__selected-options {
    min-width: 60px !important;
    > * {
      margin: 2px;
    }
    .vs__actions {
      padding: 2px;
    }
  }
}
</style>

<style scoped lang="scss">

.chart-card {

  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  // padding: 20px;
  max-width: 100%;
  // max-height: 200px;
  canvas {
    // height: 100% !important;
    // width: 100% !important;
    height: 200px !important;
  }

}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 20px;
  padding-bottom: 0;
}

.chart-body {
  padding: 20px;
}

.chart-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

.chart-subtitle {
  font-size: 14px;
  color: #666;
  margin: 2px 0 0 0;
}

.dropdown button {
  background: #eee;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
</style>
